import { render } from "./PartPurchaseModal.vue?vue&type=template&id=e778e656"
import script from "./PartPurchaseModal.vue?vue&type=script&lang=js"
export * from "./PartPurchaseModal.vue?vue&type=script&lang=js"
script.render = render

export default script